<template>
  <div class="event-category-filter">
    <div class="menu-opener">
      <a href="#">{{ getEventCategoryLabel(currentCategory) }}</a>
    </div>
    <ul class="filters">
      <li v-for="category in categories">
        <span>
          <a href="#" @click.prevent="currentCategory = category">{{ getEventCategoryLabel(category) }}</a>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { EventCategory, eventCategories, getEventCategoryLabel } from "@/domain/events/event-category";

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: String
  },
  data() {
    return {
      currentCategory: EventCategory.LATEST,
      categories: eventCategories
    }
  },
  methods: {
    getEventCategoryLabel
  },
  watch: {
    modelValue: {
      handler(newValue) {
        this.currentCategory = newValue
      },
      immediate: true
    },
    currentCategory(newValue) {
      this.$emit("update:modelValue", newValue);
    }
  }
}
</script>

<style scoped lang="scss">
  .event-category-filter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
</style>
